export const MEDICATION = 'Medication';
export const MEMBERSHIP = 'Membership';
export const LABS = 'Labs';
export const UNCATEGORIZED = 'Uncategorized';

export const billTypes = {
	medications: 'Medication',
	membership: 'Membership',
	labs: 'Labs',
	appointment: 'Appointment',
	uncategorized: 'Uncategorized',
};
